import React from 'react';
import './style.css';
import placeholder from '../../../../../Assets/logoIsNotAvailable.png';
import {Button, Image, Popconfirm} from 'antd';
import {applicationConfig} from '../../../../../Util/config';
import {
  addHttpsToUrl,
  truncateHtmlToWords,
} from '../../../../../Util/commonUtility';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import AdsFormComponent from '../../AdsForm';
import view_more_svg from '../../../../../Assets/view-more-right-arrow.svg';
import useLocalization from '../../../../../Localization';
import {
  deleteAdById,
  editAdStatusById,
  fetchAdsByUserId,
} from '../../../../../Store/Actions';
import {getLocalStorageUserInfo} from '../../../../../Util/commonUtility';
import {QuestionCircleOutlined} from '@ant-design/icons';
import AdJobReceipt from '../../../../CommonComponents/receiptComponent/AdJobReceipt';

const CommonAdsListingCard = (props) => {
  const {
    adsLogo,
    adsHeading,
    adsDescription,
    adsStatus,
    url,
    id,
    adFeesOptions,
    ad_fee,
    ad_fee_note,
    is_paid,
    months,
    payment,
    showDeactivateButton = true,
  } = props;
  const navigate = useNavigate();
  const {ApplicationString} = useLocalization();
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = React.useState(false);

  const isAdPayable =
    adsStatus === 'draft' ||
    (adsStatus === 'in_review' && ad_fee > 0 && !is_paid);
  const isAdEditable =
    adsStatus === 'draft' || (adsStatus === 'in_review' && ad_fee > 0);
  const isAdDeactivatable = adsStatus === 'approved' && showDeactivateButton;
  const isDeletable = adsStatus === 'draft';

  const handleDeactivateAd = () => {
    dispatch(editAdStatusById(id, 'deactivate')).then(() => {
      const userInfo = getLocalStorageUserInfo();
      const userId = userInfo ? userInfo.id : '';
      dispatch(
        fetchAdsByUserId(userId, '', '', () => {}, undefined, undefined, ''),
      );
    });
  };

  const handleDeleteAd = () => {
    if (isDeleting) {
      return;
    }
    setIsDeleting(true);
    dispatch(deleteAdById(id))
      .then((deleted) => {
        if (!deleted) {
          return;
        }
        const userInfo = getLocalStorageUserInfo();
        const userId = userInfo ? userInfo.id : '';
        dispatch(
          fetchAdsByUserId(userId, '', '', () => {}, undefined, undefined, ''),
        );
      })
      .finally(() => {
        setIsDeleting(false);
      });
  };

  return (
    <React.Fragment>
      <div className='common-ads-listing-card-container'>
        <div className='common-ads-listing-card'>
          {/* <div className='common-ads-listing-card-logo-container'>
            <Image.PreviewGroup className='common-ads-listing-card-image-preview'>
              <Image
                crossOrigin='anonymous'
                prefixCls='common-ads-listing-card-logo'
                // width={90}
                preview={adsLogo?.name ? true : false}
                height={70}
                src={
                  adsLogo
                    ? `${applicationConfig.UPLOAD_URL}/${adsLogo?.name}`
                    : placeholder
                }
              />
            </Image.PreviewGroup>
          </div> */}
          <div className='common-ads-listing-card-content-wrapper'>
            <div className='common-ads-listing-card-textAndButton'>
              <div className='common-ads-listing-card-textDetails'>
                <a
                  className='common-ads-listing-card-textDetails-heading hyperlink'
                  href={addHttpsToUrl(url)}
                  target='_blank'
                  rel='noopener noreferrer'>
                  {adsHeading}
                </a>
                <span className='common-ads-listing-card-textDetails-description'>
                  {truncateHtmlToWords(adsDescription, 20)}
                </span>
              </div>
            </div>
            {
              <AdsFormComponent
                isModalOpen={editModalOpen}
                setIsModalOpen={setEditModalOpen}
                editData={props}
                adFeesOptions={adFeesOptions}
              />
            }
            {/* <div className='common-ads-listing-card-status-container'>
              <div className='common-ads-listing-card-status'>
                <img
                  src={getColorStatus(adsStatus).svg}
                  alt='ads-status-svg'
                  className='ads-listing-card-statusImg'
                />
                <span className={getColorStatus(adsStatus).className}>
                  {getColorStatus(adsStatus).normalizeName}
                </span>
              </div>
            </div> */}
            <div className='ads-listing-card-action-button-container'>
              <div className='ads-listing-card-action-button'>
                {is_paid && payment && (
                  <div className='common-ads-listing-card-download-button-container'>
                    <AdJobReceipt type='ad' item={props} />
                  </div>
                )}
                <div className='common-job-listing-card-action-container'>
                  {isAdPayable && (
                    <Button
                      id={`myProfileAds-payButton-${id}`}
                      className='common-ads-listing-card-button'
                      onClick={() => navigate(`/ads/cart/${id}`)}>
                      <span className='link-no-style'>
                        {
                          ApplicationString[
                            'userCommonAdsListingCard.button.pay'
                          ]
                        }
                      </span>
                    </Button>
                  )}
                  {isAdEditable && (
                    <Button
                      id={`myProfileAds-editButton-${id}`}
                      className='common-ads-listing-card-button'
                      onClick={() => setEditModalOpen(!editModalOpen)}>
                      {
                        ApplicationString[
                          'userCommonAdsListingCard.button.edit'
                        ]
                      }
                    </Button>
                  )}
                  {isDeletable && (
                    <Popconfirm
                      title={ApplicationString[
                        'adminActionsDropdownComponent.deleteConfirmTitle'
                      ]('ad')}
                      description={
                        ApplicationString[
                          'adminActionsDropdownComponent.deleteConfirmDescription'
                        ]
                      }
                      onConfirm={handleDeleteAd}
                      okText={
                        ApplicationString[
                          'adminActionsDropdownComponent.deleteConfirmOkText'
                        ]
                      }
                      cancelText={
                        ApplicationString[
                          'adminActionsDropdownComponent.deleteConfirmCancelText'
                        ]
                      }
                      okType='danger'
                      icon={
                        <QuestionCircleOutlined
                          style={{
                            color: 'red',
                          }}
                        />
                      }>
                      <Button
                        id={`myProfileAds-deleteButton-${id}`}
                        className='common-ads-listing-card-button'
                        disabled={isDeleting}>
                        {
                          ApplicationString[
                            'userCommonAdsListingCard.button.delete'
                          ]
                        }
                      </Button>
                    </Popconfirm>
                  )}
                  {isAdDeactivatable && (
                    <Popconfirm
                      title='Deactivate this ad?'
                      description='This ad will be hidden from active listings.'
                      onConfirm={handleDeactivateAd}
                      okText='Yes'
                      cancelText='No'
                      okType='primary'
                      icon={
                        <QuestionCircleOutlined
                          style={{
                            color: '#faad14',
                          }}
                        />
                      }>
                      <Button className='common-ads-listing-card-button'>
                        Deactivate
                      </Button>
                    </Popconfirm>
                  )}
                </div>
                <Button
                  id={`myProfileAds-checkButton-${id}`}
                  className='view-more-svg-button'>
                  <a
                    className='link-no-style'
                    href={addHttpsToUrl(url)}
                    target='_blank'
                    rel='noopener noreferrer'>
                    {
                      ApplicationString[
                        'userCommonAdsListingCard.button.checkItOut'
                      ]
                    }
                  </a>
                  <img
                    src={view_more_svg}
                    alt='view_more_svg'
                    className='view-more-svg'
                  />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CommonAdsListingCard;
